import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import CustomTips from './CustomTips';

export function SectionTopTitle({
  title,
  popoverDetail,
  popoverImage,
}) {
  const haveTips = popoverDetail || popoverImage;

  return <label
    className="create-section-title"
    style={haveTips ? { display: "flex" } : {}}
  >
    {title}
    {haveTips &&
      <CustomTips
        popoverClassName="tips-popover"
        detail={popoverDetail}
        innerImage={popoverImage}
      />}
  </label>
}

export function FieldControl({ name, rules = {}, render }) {
  const { control } = useFormContext();
  return (
    <Controller control={control} name={name} rules={rules} render={render} />
  );
}
